import {Dispatch} from "redux";
import {ErrorDtoFactory} from "../../dtos/errorDto";
import {TShelvesScreenActions} from "../actions/shevesScreenAction";
import {TShelfPromoActions} from "../actions/shelfPromoAction";
import {ActionType} from "../actionTypes";
import axios from "axios";
import envManager from "../../com/envManager/EnvManager";
import {buildStoreDataObj, calculateNumberOfShelves} from "../../com/globalsFunctions/globalFunctions";
import {
    IShelvesCategoryTreeChildDto,
    IShelvesDataDto,
} from "../../dtos/flyer";

export const getShelvesData = (
    requestIdForStore: number,
    height: number,
    width: number,
    isLandscape: boolean,
    flyerId: number,
    isFromCategory?: boolean,
    isFullHeight: boolean = false) => {
    return async (dispatch: Dispatch<TShelvesScreenActions>) => {
        dispatch({
            type: ActionType.GET_SHELVES_DATA_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            console.log(envManager);
            let url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForItem`;
            const shelvesNumber: number = calculateNumberOfShelves(isLandscape);
            const shopperDataWithId = localStorage.getItem('FlyerShopperId');
            let flyerShopperId: number;
            if (shopperDataWithId) {
                flyerShopperId = Number(localStorage.getItem('FlyerShopperId'));
            } else {
                flyerShopperId = 0;
            }

            let dataForRequest: any = {
                flyerId: flyerId,
                itemId: requestIdForStore,
                canvasSpec: {
                    viewport: {
                        width: width,
                        height: height
                    }
                },
                storeSpec: {
                    shelvesPerView: shelvesNumber
                },
                rackSpec: {
                    itemThumbnailResizing: isFullHeight ? 1 : 3
                },
                shopperId: flyerShopperId
            };
            if (isFromCategory) {
                url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel2Category`;
                dataForRequest = {
                    flyerId: flyerId,
                    level2CategoryId: requestIdForStore,
                    canvasSpec: {
                        viewport: {
                            width: width,
                            height: height
                        }
                    },
                    storeSpec: {
                        shelvesPerView: shelvesNumber
                    },
                    rackSpec: {
                        itemThumbnailResizing: isFullHeight ? 1 : 3
                    },
                    shopperId: flyerShopperId
                }
            }
            let result = await axios.post(url, dataForRequest, config);
            let data = result.data.data;
            const convertedDataToCorrectStructure: IShelvesDataDto = buildStoreDataObj(data);

            dispatch({
                type: ActionType.GET_SHELVES_DATA_SUCCESS,
                payload: {
                    data: convertedDataToCorrectStructure,
                    elapsedTimeSecs: result.data.elapsedTimeSecs
                },
            });

            dispatch({
                type: ActionType.GET_SHELVES_DATA_COMPLETE,
            });
        } catch (err) {
            dispatch({
                type: ActionType.GET_SHELVES_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getStoreData = (
    accountName: string,
    height: number,
    width: number,
    isLandscape: boolean,
    categoryLVL1Caption: string,
    categoryLVL2Caption: string,
    categoryLVL3Caption: string,
    isFullHeight: boolean = false,
    requestLvl: number = 0,
    storeId: string,
    langCode: string,
    itemCode: string | null = null
) => {
    return async (dispatch: Dispatch<TShelvesScreenActions>) => {
        dispatch({
            type: ActionType.GET_SHELVES_DATA_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            console.log(envManager);
            let url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel0CategoryCaption`;
            switch (requestLvl) {
                case 1:
                    url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel1CategoryCaption`;
                    break;
                case 2:
                    url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel2CategoryCaption`;
                    break;
                case 3:
                    url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel3CategoryCaption`;
                    break;
                case 4:
                    url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreForLevel4Code`;
                    break;
            }

            const shelvesNumber: number = calculateNumberOfShelves(isLandscape);
            const shopperDataWithId = localStorage.getItem('StoreShopperId');
            const basketWithId = localStorage.getItem('BasketId');
            let storeShopperId: number;
            if (shopperDataWithId) {
                storeShopperId = Number(localStorage.getItem('StoreShopperId'));
            } else {
                storeShopperId = 0;
            }
            if (!basketWithId) {
                localStorage.setItem('BasketId', '0');
            }
            let dataForRequest: any = {
                accountCaption: accountName,
                level1CategoryCaption: requestLvl === 4 ? null : categoryLVL1Caption,
                level2CategoryCaption: requestLvl === 4 ? null : categoryLVL2Caption,
                level3CategoryCaption: requestLvl === 4 ? null : categoryLVL3Caption,
                level4Code: itemCode,
                languageCultureCode: langCode,
                storeSettingId: storeId ? Number(storeId) : null,
                canvasSpec: {
                    viewport: {
                        width: width,
                        height: height
                    }
                },
                storeSpec: {
                    shelvesPerView: shelvesNumber
                },
                rackSpec: {
                    itemThumbnailResizing: isFullHeight ? 1 : 3
                },
                shopperId: storeShopperId
            };
            let result = await axios.post(url, dataForRequest, config);
            let data = result.data.data;
            const convertedDataToCorrectStructure: IShelvesDataDto = buildStoreDataObj(data);
            dispatch({
                type: ActionType.GET_SHELVES_DATA_SUCCESS,
                payload: {
                    data: convertedDataToCorrectStructure,
                    elapsedTimeSecs: result.data.elapsedTimeSecs
                },
            });
            localStorage.setItem("StoreShopperId", `${data.shopperId || 0}`);

            dispatch({
                type: ActionType.GET_SHELVES_DATA_COMPLETE,
            });
        } catch (err) {
            dispatch({
                type: ActionType.GET_SHELVES_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getStoreDataFromKeywords = (
    keywords: string = "",
    accountID: number = 0,
    height: number,
    width: number,
    isLandscape: boolean,
    isFullHeight: boolean = false,
    storeId: string | null,
) => {
    return async (
        dispatch: Dispatch<TShelvesScreenActions>
    ) => {
        dispatch({
            type: ActionType.GET_SHELVES_DATA_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            console.log(envManager);
            let url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetVirtualStoreByKeywords`;
            const shelvesNumber: number = calculateNumberOfShelves(isLandscape);
            const shopperDataWithId = localStorage.getItem('StoreShopperId');
            const basketWithId = localStorage.getItem('BasketId');
            let storeShopperId: number;
            if (shopperDataWithId) {
                storeShopperId = Number(localStorage.getItem('StoreShopperId'));
            } else {
                storeShopperId = 0;
            }
            if (!basketWithId) {
                localStorage.setItem('BasketId', '0');
            }
            let dataForRequest: any = {
                accountId: accountID,
                keywords: keywords,
                storeSettingId: storeId ? Number(storeId) : null,
                canvasSpec: {
                    viewport: {
                        width: width,
                        height: height
                    }
                },
                storeSpec: {
                    shelvesPerView: shelvesNumber
                },
                rackSpec: {
                    itemThumbnailResizing: isFullHeight ? 1 : 3
                },
                shopperId: storeShopperId
            };
            let result = await axios.post(url, dataForRequest, config);
            let data = result.data.data;
            const convertedDataToCorrectStructure: IShelvesDataDto = buildStoreDataObj(data);
            dispatch({
                type: ActionType.GET_SHELVES_DATA_SUCCESS,
                payload: {
                    data: convertedDataToCorrectStructure,
                    elapsedTimeSecs: result.data.elapsedTimeSecs,
                    isDisplayCategories: false
                },
            });
            localStorage.setItem("StoreShopperId", `${data.shopperId || 0}`);

            dispatch({
                type: ActionType.GET_SHELVES_DATA_COMPLETE,
            });
        } catch (err) {
            dispatch({
                type: ActionType.GET_SHELVES_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    }
}

export const toggleShelvesScreen = (itemId: number | null) => {
    return async (
        dispatch: Dispatch<TShelvesScreenActions | TShelfPromoActions>
    ) => {
        dispatch({
            type: ActionType.TOGGLE_SHELVES_SCREEN,
            payload: itemId,
        });
        dispatch({
            type: ActionType.TOGGLE_SHELF_PROMO_DETAILS_POPUP,
            payload: false,
        });
    };
};

export const changeCategoriesSelectionForShelvesScreen = (categories: IShelvesCategoryTreeChildDto[]) => {
    return async (
        dispatch: Dispatch<TShelvesScreenActions>
    ) => {
        dispatch({
            type: ActionType.CHANGE_CATEGORY_SELECTION,
            payload: categories,
        });
    };
};
